module.exports = __webpack_public_path__ + "static/media/hand-heart.6aaae718.svg";